/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntraGroupSyncSummaryResponse
 */
export interface EntraGroupSyncSummaryResponse {
    /**
     * 
     * @type {any}
     * @memberof EntraGroupSyncSummaryResponse
     */
    roleId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof EntraGroupSyncSummaryResponse
     */
    roleMappedToGroup?: boolean;
    /**
     * 
     * @type {any}
     * @memberof EntraGroupSyncSummaryResponse
     */
    added?: any | null;
    /**
     * 
     * @type {any}
     * @memberof EntraGroupSyncSummaryResponse
     */
    skipped?: any | null;
    /**
     * 
     * @type {any}
     * @memberof EntraGroupSyncSummaryResponse
     */
    failed?: any | null;
}

/**
 * Check if a given object implements the EntraGroupSyncSummaryResponse interface.
 */
export function instanceOfEntraGroupSyncSummaryResponse(value: object): value is EntraGroupSyncSummaryResponse {
    return true;
}

export function EntraGroupSyncSummaryResponseFromJSON(json: any): EntraGroupSyncSummaryResponse {
    return EntraGroupSyncSummaryResponseFromJSONTyped(json, false);
}

export function EntraGroupSyncSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntraGroupSyncSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'roleId': json['roleId'] === undefined ? undefined : json['roleId'] === null ? null : json['roleId'],
        'roleMappedToGroup': json['roleMappedToGroup'] == null ? undefined : json['roleMappedToGroup'],
        'added': json['added'] === undefined ? undefined : json['added'] === null ? null : json['added'],
        'skipped': json['skipped'] === undefined ? undefined : json['skipped'] === null ? null : json['skipped'],
        'failed': json['failed'] === undefined ? undefined : json['failed'] === null ? null : json['failed'],
    };
}

export function EntraGroupSyncSummaryResponseToJSON(json: any): EntraGroupSyncSummaryResponse {
    return EntraGroupSyncSummaryResponseToJSONTyped(json, false);
}

export function EntraGroupSyncSummaryResponseToJSONTyped(value?: EntraGroupSyncSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleId': value['roleId'],
        'roleMappedToGroup': value['roleMappedToGroup'],
        'added': value['added'],
        'skipped': value['skipped'],
        'failed': value['failed'],
    };
}

